import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  MenuItem,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  useMediaQuery,
   Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { useFormik } from "formik";
import {
  useCreateModifierGroupMutation,
  useGetAllMainModifierCategoryQuery,
  useGetLastProductIdQuery,
  useGetPrinterQuery,
  useGetProductBrandQuery,
  useGetProductTagQuery,
  useGetSubCategoryByArrayQuery,
  useGetModifierQuery
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {
  ICategory,
  ILastProductId,
  IPrinter,
  IProduct,
  IModifierPopUp,
  IModifierGroup,
  IProductBrand,
  IProductTag,
  ModifierInfo,
} from "../../../Api/Interface/api.interface";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Switch, { SwitchProps } from "@mui/material/Switch";
import AddIcon from "@mui/icons-material/Add";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import CustomSwitch from "../../../Components/Switch/CustomSwitch";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import { HexColorPicker } from "react-colorful";
import Barcode from "react-barcode";
import AppsIcon from "@mui/icons-material/Apps";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import NewProductBrand from "../../ProductBrand/Edit/index";
import NewPrinter from "../../Printer/Edit/index";
import NewProductTag from "../../ProductTags/Edit/index";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import { uploadImage } from "../../../Components/UploadFile/upload";
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';


const steps = ["Basic Details", "Looping Table", "Done"];

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(28px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 30, // Increased thumb size
    height: 30, // Increased thumb size
  },
  "& .MuiSwitch-track": {
    borderRadius: 34 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#757575" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`, // Using SVG path for check
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`, // Using SVG path for minus
      right: 12,
    },
  },
}));

const isPrinterArray = (data: any): data is IPrinter[] => {
  return (
    Array.isArray(data) &&
    data.every(
      (item) =>
        "id" in item && "printerName" in item && "printerDescription" in item
    )
  );
};

// Image imports
const img1 = require("../../../Images/img1.jpg");
const img2 = require("../../../Images/img2.jpg");
const img3 = require("../../../Images/img3.jpg");

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const gridHeight = isMobile ? "30px" : "400px";

  const [newModifierGroup, { isLoading }] = useCreateModifierGroupMutation();
  const { showErrorMessage, showMessage } = useNotifier();
  const { data: categoryData } = useGetAllMainModifierCategoryQuery({
    departmentId: "",
    coursingId: "",
    roleId: null,
    taxeId: "",
    createdDateStart: null,
    createdDateEnd: null,
    searchText: "",
    numberOfLength: 0,
    isActive: true,
    categoryIsLooping: null,
    createdDate: null,
  });
 const { data: modifierData } = useGetModifierQuery({
   productBrandId:  null,
  productCategoryId:  null,
  productTagIds: null,
  modifierViewOnline:null,
  createdDateEnd:  null,
  createdDateStart:null,
  searchText: null,
  createdDate: null,
  id:  "",
  });

  const { data: productBrandData, isLoading: ProductBrandLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });
  const { data: productTagData, isLoading: ProductTagLoading } =
    useGetProductTagQuery({
      searchText: "",
      isActive: true,
    });
  const { data: printerData, isLoading: PrinterLoading } = useGetPrinterQuery({
    searchText: "",
  });

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);

  const [openProductCategory, setOpenProductCategory] = useState(false);
  const [openProductBrand, setOpenProductBrand] = useState(false);
  const [openProductTag, setOpenProductTag] = useState(false);
  const [openPrinter, setOpenPrinter] = useState(false);
  const [selectedColor, setSelectedColor] = useState<string>("#FFFFFF");
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorPickerRef = useRef<HTMLDivElement>(null);
  const { data: newLastProductIdData, isLoading: lastProductIdIsLoading } =
    useGetLastProductIdQuery();
  const [showBarcode, setShowBarcode] = useState(false);

  const [openLoopingCategoryDialog, setOpenLoopingCategoryDialog] =
    useState(false);
    const [overwriteChoice, setOverwriteChoice] = useState<Record<number, 'yes' | 'no'>>({});
   const [overwritePrices, setOverwritePrices] = useState<Record<number, number>>({});
const [modifiers, setModifiers] = React.useState<ModifierInfo[]>([]);
const selectedModifierIds = modifiers.map((m) => m.modifier_id);

  const [openGallery, setOpenGallery] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File | undefined>(
    undefined
  );

      const modifierList = useMemo(() => {
    return modifierData?.data as IModifierPopUp[];
  }, [modifierData?.data]);

    const categoryList = useMemo(() => {
      return categoryData?.data as ICategory[];
    }, [categoryData?.data]);

     const filteredModifiers = useMemo(() => {
  return modifierList?.filter(
    (mod) => Number(mod.productCategoryId) === Number(selectedCategoryId)
  );
}, [modifierList, selectedCategoryId]);

  const formik = useFormik<IModifierGroup>({
    initialValues: {
      modifierGroupName: "",
      modifierCategoryId: "",
      modifierLongDescription: "",
      modifiers: [], 
      minimum: 0,
      maximum: 0,
      isActive: true,
    },
    onSubmit: async (values, { resetForm }) => {
      try {
     
    const modifierDetails = modifiers.map((mod) => ({
  modifier_id: mod.modifier_id,
  overwrite: mod.overwrite,
  overwrite_price: mod.overwrite ? mod.overwrite_price ?? 0 : null,
}));


        const formData = new FormData();

        const temData = {
          modifierGroupName: values.modifierGroupName,
          modifierCategoryId: selectedCategoryId,
          modifiers: modifierDetails, 
           minimum: values.minimum,
           maximum: values.maximum,
          modifierLongDescription: values.modifierLongDescription,
          isActive: values.isActive,
        };

        const addProductResponse = await newModifierGroup(temData).unwrap();
        if (!addProductResponse.status) {
          showErrorMessage(addProductResponse.message);
        } else {
          showMessage(addProductResponse.message);
          navigate("/modifierGroup/list");
          resetForm();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return formik.values.modifierGroupName === "" ||
      formik.values.modifierGroupName === undefined
      ? false
      : true;
  }, [formik]);

  
  const openGalleryDialog = () => {
    setOpenGallery(true);
  };

  const closeGalleryDialog = () => {
    setOpenGallery(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        colorPickerRef.current &&
        !colorPickerRef.current.contains(event.target as Node)
      ) {
        setShowColorPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  
const handleModifierChange = (e: React.ChangeEvent<{ value: unknown }>) => {
  const value = e.target.value;
  const selectedIds =
    typeof value === "string"
      ? value.split(',').map(Number)
      : (value as number[]);

  const newModifiers = selectedIds.map((id) => {
    const existing = modifiers.find((m) => m.modifier_id === id);
    return existing ?? {
      modifier_id: id,
      overwrite: false,
      overwrite_price: null,
    };
  });

  setModifiers(newModifiers);
};

const handleAddModifier = (modifier: IModifierPopUp) => {
  const alreadyAdded = modifiers.some((m) => m.modifier_id === modifier.id);
  if (!alreadyAdded) {
    setModifiers([
      ...modifiers,
      {
        modifier_id: modifier.id,
        overwrite: false,
        overwrite_price: null,
      },
    ]);
  }
};


const handleMainCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const categoryId = event.target.value as number;
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
    formik.setFieldValue("mainCatId", categoryId);

    const selectedCategory = categoryList.find(
      (category) => category.id == categoryId
    );

    if (selectedCategory) {
      formik.setFieldValue(
        "productDetailsIsLooping",
        selectedCategory.categoryIsLooping
      );
      formik.setFieldValue(
        "productsDetailsLoopingConstant",
        selectedCategory.categoryLoopingConstant
      );
    }
  };

  
  if (
    isLoading ||
    ProductBrandLoading ||
    ProductTagLoading ||
    PrinterLoading ||
    lastProductIdIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const cancelFunction = () => {
    formik.resetForm();
    setSelectedImage(undefined);
    setOpenGallery(false);
    setSelectedCategoryId(null);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
  };

 


  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={3} md={3} sm={12} xs={12}>
          <Card className={classes.stepperCard}>
           {/* <Grid
                         container
                         justifyContent={"space-between"}
                         spacing={5}
                         sx={{ borderBottom: 2, padding: 2 }}
                         className={classes.titleGrid}
                       >
                         <Grid
                           item
                           lg={12}
                           md={12}
                           sm={12}
                           xs={12}
                           pt={2}
                           alignContent={"center"}
                         >
                           <Typography className={classes.cardTitle}>
                             Create Modifier Group
                           </Typography>
                         </Grid>
                       </Grid> */}
          </Card>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          {/* {activeStep === 0 ? ( */}
            <form onSubmit={formik.handleSubmit}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12} >
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                        Modifier Group Information
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                      <Grid item lg={9} md={9} sm={12} xs={12}>
                        <Grid container alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                             Name
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                              placeholder="Enter Name"
                              size="small"
                              {...formik.getFieldProps("modifierGroupName")}
                              className={classes.textField}
                              InputProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                     

                        <Grid item lg={9} md={9} sm={12} xs={12}>
                                             <Grid container alignItems="center">
                                               <Grid item lg={12} md={12} sm={12} xs={12}>
                                                 <Typography variant="subtitle1">
                                                   Modifier Category
                                                 </Typography>
                                               </Grid>
                                               <Grid
                                                 item
                                                 lg={12}
                                                 md={12}
                                                 sm={12}
                                                 xs={12}
                                                 display="flex"
                                                 alignItems="center"
                                               >
                                                 <TextField
                                                   select
                                                   fullWidth
                                                   size="small"
                                                   className={classes.textField}
                                                   value={selectedCategoryId || ""}
                                                   onChange={handleMainCategoryChange}
                                                   InputLabelProps={{ shrink: true }}
                                                 >
                                                   <MenuItem
                                                     value=""
                                                     disabled
                                                     style={{ color: "gray" }}
                                                   >
                                                     Select an option
                                                   </MenuItem>
                                                   {categoryList &&
                                                     categoryList.map((category) => (
                                                       <MenuItem
                                                         key={category.id}
                                                         value={category.id}
                                                       >
                                                         {category.categoryName}
                                                       </MenuItem>
                                                     ))}
                                                 </TextField>
                                               </Grid>
                                             </Grid>
                                           </Grid>

             {selectedCategoryId && (
  <Grid item lg={4} md={4} sm={12} xs={12}>
    <Typography variant="subtitle1">Available Modifiers</Typography>
    <Box sx={{ border: '1px solid #ccc', padding: 2, height: 300, overflowY: 'auto' }}>
      {modifierList
       .filter((mod) =>
  String(mod.productCategoryId) === String(selectedCategoryId) &&
  !modifiers.some((m) => m.modifier_id === mod.id)
)
        .map((mod) => (
        <Box
          key={mod.id}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography>{mod.modifierName}</Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleAddModifier(mod)}
          >
            Add
          </Button>
        </Box>
      ))}
    </Box>
  </Grid>
             )}
                              

                      {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                        <Grid container alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              Select Modifiers
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
  select
  size="small"
  className={classes.textField}
  SelectProps={{
    multiple: true,
    native: false,
  }}
  value={selectedModifierIds}
  onChange={handleModifierChange}

  InputLabelProps={{ shrink: true }}
>
  <MenuItem value="" disabled>
    Select some option
  </MenuItem>
  {modifierList.map((modifier) => (
    <MenuItem key={modifier.id} value={modifier.id}>
      {modifier.modifierName}
    </MenuItem>
  ))}
</TextField>

                          </Grid>
                        </Grid>
                      </Grid> */}



            
        {selectedCategoryId && (
          
  <Grid item xs={8}>
        <Typography variant="subtitle1">Added Modifiers</Typography>

     <Box sx={{ border: '1px solid #ccc', padding: 2,height: 300, overflowY: 'auto' }}>
     <TableContainer>
    <Table className={classes.table}>
      <TableHead className={classes.tableHeaderRow}>
        <TableRow>
          <TableCell className={classes.tablheader}><strong>Modifier</strong></TableCell>
          <TableCell className={classes.tablheader}><strong>Price</strong></TableCell>
          {/* <TableCell className={classes.tablheader}><strong>Overwrite?</strong></TableCell>
          <TableCell className={classes.tablheader}><strong>Overwrite Price</strong></TableCell> */}
          <TableCell className={classes.tablheader}><strong>Action</strong></TableCell>
        </TableRow>
      </TableHead>
    <TableBody>
  {modifiers.map((mod, index) => {
    const modInfo = modifierList.find((m) => m.id === mod.modifier_id);
    return (
      <TableRow key={mod.modifier_id}>
        <TableCell>{modInfo?.modifierName}</TableCell>
        <TableCell>${modInfo?.modifierPrice ?? 0}</TableCell>
        {/* <TableCell>
          <TextField
            select
            size="small"
            value={mod.overwrite ? 'yes' : 'no'}
            onChange={(e) => {
              const updated = [...modifiers];
              updated[index] = {
                ...updated[index],
                overwrite: e.target.value === 'yes',
                overwrite_price:
                  e.target.value === 'yes'
                    ? updated[index].overwrite_price ?? 0
                    : null,
              };
              setModifiers(updated);
            }}
          >
            <MenuItem value="no">No</MenuItem>
            <MenuItem value="yes">Yes</MenuItem>
          </TextField>
        </TableCell>
        <TableCell>
          {mod.overwrite && (
            <TextField
              type="number"
              size="small"
              value={mod.overwrite_price ?? ''}
              onChange={(e) => {
                const updated = [...modifiers];
                updated[index] = {
                  ...updated[index],
                  overwrite_price: parseFloat(e.target.value),
                };
                setModifiers(updated);
              }}
            />
          )}
        </TableCell> */}
        <TableCell>
           <IconButton
    size="small"
    color="error"
    onClick={() => {
      const updated = modifiers.filter(
        (item) => item.modifier_id !== mod.modifier_id
      );
      setModifiers(updated);
    }}
      sx={{
      backgroundColor: '#f8d7da',
      borderRadius: '50%',
      padding: '4px',
      '&:hover': {
        backgroundColor: '#f1b0b7',
      },
    }}
  >
    <CloseIcon fontSize="small" />
  </IconButton>
        </TableCell>
      </TableRow>
    );
  })}
</TableBody>

    </Table>
    </TableContainer>
    </Box>
  </Grid>
     )}
     
   {/* <Grid item lg={4} md={4} sm={12} xs={12} >
        <Typography variant="subtitle1">Minimum Selection</Typography>
        <TextField
          type="number"
          size="small"
          placeholder="Minimum"
          {...formik.getFieldProps("minimum")}
          className={classes.textField}
          InputProps={{
            sx: {
              fontSize: 14,
            },
          }}
        />
      </Grid>

       <Grid item lg={4} md={4} sm={12} xs={12}>
        <Typography variant="subtitle1">Maximum Selection</Typography>
        <TextField
          type="number"
          size="small"
          placeholder="Maximum"
          {...formik.getFieldProps("maximum")}
          className={classes.textField}
          InputProps={{
            sx: {
              fontSize: 14,
            },
          }}
        />
      </Grid> */}


                      <Grid item lg={4} md={4} sm={4} xs={6}>
                        <Grid container alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">Active</Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <CustomSwitch
                              color="primary"
                              sx={{ mr: 2 }}
                              formik={formik}
                              name="isActive"
                            />
                          </Grid>
                        </Grid>
                      </Grid>

                 


                      <Grid item lg={9} md={9} sm={12} xs={12}>
                        <Grid container alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                               Description
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                              placeholder="Enter Long Description .."
                              size="small"
                              multiline
                              rows={8}
                              {...formik.getFieldProps("modifierLongDescription" )}
                              className={classes.discriptionTextField}
                              InputProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={cancelFunction}
                        >
                          Cancel
                        </Button>
                        <Box m={0.5}></Box>

                        <Button
                          variant="contained"
                          startIcon={<SaveAltIcon />}
                          className={classes.addButton}
                          onClick={() => formik.handleSubmit()}
                          disabled={!formValid || isLoading}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
              <Dialog open={openGallery} onClose={closeGalleryDialog}>
                <Grid className={classes.Dialog}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Select an Image from Gallery
                      </Typography>
                    </Grid>
                  </Grid>
                  <DialogContent>
                   
                  </DialogContent>
                </Grid>
              </Dialog>

              {openProductBrand && (
                <NewProductBrand
                  handleCloseDialog={() => setOpenProductBrand(false)}
                  openModel={openProductBrand}
                />
              )}

              {openProductTag && (
                <NewProductTag
                  handleCloseDialog={() => setOpenProductTag(false)}
                  openModel={openProductTag}
                />
              )}

              {openPrinter && (
                <NewPrinter
                  handleCloseDialog={() => setOpenPrinter(false)}
                  openModel={openPrinter}
                />
              )}
            </form>
          {/* )  */}
          {/* : activeStep === 1 ? (
            <LoopingTable
              productName={modifiers.productName}
              productId={modifiers.id}
              productDetailsIsLooping={modifiers.productDetailsIsLooping}
              productsDetailsLoopingConstant={
                modifiers.productsDetailsLoopingConstant
              }
              loopingTableComplete={handleLoopingTableComplete}
            />
          )  */}
          {/* : (
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      py={2}
                      alignContent={"center"}
                      textAlign={"center"}
                    >
                      <Typography className={classes.cardTitle} p={10}>
                        Modifier Created Successfully
                      </Typography>
                      <Button
                        variant="contained"
                        startIcon={<TaskAltIcon />}
                        className={classes.addButton}
                        onClick={handleOkay}
                        disabled={isLoading}
                      >
                        Done
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          ) */}
          {/* } */}
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
